import { render, staticRenderFns } from "./Scale_topic_addition.vue?vue&type=template&id=204fe25a"
import script from "./Scale_topic_addition.vue?vue&type=script&lang=js"
export * from "./Scale_topic_addition.vue?vue&type=script&lang=js"
import style0 from "./Scale_topic_addition.vue?vue&type=style&index=0&id=204fe25a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports